import dashboardSVG from '../img/dashboard.svg';
import usersSVG from '../img/users.svg';
import plusSVG from '../img/plus.svg';
import myTransfersSVG from '../img/my-transfers.svg';
import transactionsSVG from '../img/transactions.svg';
// import paymentSVG from '../img/payment.svg';
// import paymentActiveSVG from '../img/payment-active.svg';
import paymentHistorySVG from '../img/payment-history.svg';
import paymentHistoryActiveSVG from '../img/payment-history-active.svg';
import betHistorySVG from '../img/bet-history.svg';
import myStatisticsSVG from '../img/my-statistics.svg';
import generalReportSVG from '../img/general-report.svg';

export const sideMenuItems = [
  [
    {
      icon: dashboardSVG,
      link: '/statistic/dashboard',
      text: 'dashboard',
    },
  ],
  [
    {
      icon: usersSVG,
      link: '/users-list',
      text: 'users',
      additional: {
        icon: plusSVG,
        // link: '/user-create',
      },
    },
  ],
  [
    {
      icon: myStatisticsSVG,
      link: '/my-statistic',
      text: 'myStatistic',
    },
    {
      icon: myTransfersSVG,
      link: '/total',
      text: 'myTransfers',
    },
    {
      icon: generalReportSVG,
      link: '/general-report',
      text: 'generalReport',
    },
    {
      icon: betHistorySVG,
      link: '/bet-history',
      text: 'betHistory',
    },
    {
      icon: transactionsSVG,
      link: '/transaction-history',
      text: 'transactionsHistory',
    },
  ],
  [
    // {
    //   icon: transactionsSVG,
    //   link: '/active-requests',
    //   text: 'activeRequests',
    //   roles: [1],
    // },
    // {
    //   icon: transactionsSVG,
    //   link: '/withdrawal-history',
    //   text: 'withdrawalHistory',
    //   roles: [1],
    // },
    // {
    //   icon: paymentSVG,
    //   activeIcon: paymentActiveSVG,
    //   link: '/payment/bithide',
    //   text: 'payment',
    //   roles: [3],
    // },
    {
      icon: paymentHistorySVG,
      activeIcon: paymentHistoryActiveSVG,
      link: '/payment/payment-history',
      text: 'paymentHistory',
      roles: [3],
    },
  ],
];
